<template>
  <router-link
      v-bind="$attrs"
      class="SLIDING-TABS-TITLE"
      :class="titleClass"
      :selenium="`${title.toLowerCase()}-status-tab`"
      :active-class="`${active ? `ACTIVE ${activeClass}` : ''}`">
    {{ title }}
    <span
        v-if="hasSuffix"
        class="SUFFIX"
        :class="suffixClass"
        :selenium="`${title.toLowerCase()}-count-label`">{{ suffix }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'sliding-tabs-title',
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleClass: String,
    suffix: [String, Number],
    suffixClass: String,
    active: {
      type: Boolean,
      default: false,
    },
    activeClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasSuffix () {
      return typeof this.suffix !== 'undefined';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .SLIDING-TABS-TITLE {
    @include pseudo(visited, color, $color-gray70, $color-gray70);
    @include link-black;
    @include text-medium;
    position: relative;
    height: 22px;
    margin: 1.25*$unit 0;
    padding: 0 $unit;
    text-align: center;
    font-weight: 600;

    &:after {
      @include absolute(auto, 0, 1.25*-$unit, 0);
      content: '';
      height: 3px;
      background-color: $color-gray40;
      transform: scaleY(0);
      transform-origin: bottom;
      will-change: transform;
      transition: transform $transition-half-duration;
    }

    &:hover {
      text-decoration: none !important;

      &:after {
        transform: scaleY(1);
      }
    }

    &.ACTIVE {
      color: $color-depot;
    }
  }

  .SUFFIX {
    color: $color-gray60;

    &:before {
      content: '(';
    }

    &:after {
      content: ')';
    }
  }
</style>
